import Game from '../game';
import Scene from '../scene/scene';
import BaseObject, { IdentifierType, BaseObjectParams } from '../baseObject';

export interface ControlGroupParams extends BaseObjectParams {
  scene?: Scene;
}

export default class ControlGroup extends BaseObject implements ControlGroupParams {
  scene?: Scene;

  elementsIds: Array<IdentifierType> = [];
  doubleSelectTimeout = 250; // ms
  lastSelectTimestamp = 0;

  constructor(params: ControlGroupParams)
  {
    super();
    this.applyParams(params);
  }

  setElementsIds(ids: Array<IdentifierType>): void
  {
    this.elementsIds = [...ids];
  }

  addElementsIds(ids: Array<IdentifierType>): void
  {
    this.elementsIds = [...this.elementsIds, ...ids];
  }

  focusOnMyElements(): void
  {
    const elements = Game.instance.scene.getElementsByIds(this.elementsIds);
    Game.instance?.scene?.camera?.focusElements(elements);
  }
}
